import Constant from '@/const';
import axios from 'axios';

const getServiceById = async id => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/master/service/${id}`),
    );
    return response.data.data;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getServiceById;
